import React from 'react';
import { Box } from '@mui/material';
import DosenTooltip from './DosenTooltip';

/**
 * The capability a lesson builds, shown beside the lesson's name: on the
 * admin's lesson editor and on the learner's lesson page (Cian, 2026-10-16).
 */
const CapabilityChip: React.FC<{ name: string }> = ({ name }) => (
  <DosenTooltip title="The capability this lesson builds" placement="top">
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        px: '8px',
        py: '2px',
        borderRadius: '4px',
        border: '1px solid rgba(247,148,32,0.45)',
        bgcolor: 'rgba(247,148,32,0.08)',
        color: '#F79420',
        fontFamily: 'Inter, sans-serif',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: '18px',
        whiteSpace: 'nowrap',
        cursor: 'default'
      }}
    >
      Capability: {name}
    </Box>
  </DosenTooltip>
);

export default CapabilityChip;
